import { PageTitle } from '~/@mid_ui/typography/PageTitle'
import { ArchivedProjectsTable } from './ArchivedProjectsTable'

function ArchivedProjects() {
  return (
    <>
      <PageTitle>Archív</PageTitle>
      <ArchivedProjectsTable />
    </>
  )
}

export { ArchivedProjects }
